import styled from 'styled-components';
import List from './List';

const FlatList = styled(List)`
  display: flex;
`;

export default FlatList;



// WEBPACK FOOTER //
// ./src/components/FlatList.js